module.exports = __webpack_public_path__ + "img/logo.fba7e454.svg";